import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';

function getNumberAndUnit(numberStrWithUnit) {
  var _String$match = String(numberStrWithUnit).match(/[a-z]+|[(/^\-?\d*.\d+|\d+),?]+/gi),
      _String$match2 = _slicedToArray(_String$match, 2),
      number = _String$match2[0],
      unit = _String$match2[1];

  return {
    number: number,
    unit: unit
  };
}
function op(operator, n1, n2) {
  var _getNumberAndUnit = getNumberAndUnit(n1),
      number = _getNumberAndUnit.number,
      unit = _getNumberAndUnit.unit;

  var _getNumberAndUnit2 = getNumberAndUnit(n2),
      number2 = _getNumberAndUnit2.number,
      unit2 = _getNumberAndUnit2.unit;

  switch (operator) {
    case '*':
      return Number(number) * Number(number2) + (unit || unit2);

    case '+':
      return Number(number) + Number(number2) + (unit || unit2);

    case '-':
      return Number(number) - Number(number2) + (unit || unit2);

    case '/':
      return Number(number) / Number(number2) + (unit || unit2);

    default:
      return Number(number) + Number(number2) + (unit || unit2);
  }
}

export { getNumberAndUnit, op };
//# sourceMappingURL=arithmetic.js.map
